<template>
  <router-view/>
</template>

<style>
body{
    /* 为了有一点点的padding, 方便截图 */
	padding: 5px;
}
</style>
